import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/motoboy',
  title: 'Motoboy',
  endpoint: '/app/expedition/order?sort=-createdAt&shippingMethod=Motoboy',
  breadcrumbs: [],
}
